import { configureStore } from '@reduxjs/toolkit';
import moviesReducer from './movies';
import movieReducer from './movie';

export const store = configureStore({
	reducer: {
		movies: moviesReducer,
		movie: movieReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
